import React, {useEffect, useState} from "react";
import {
  exibirMensagemErro,
  exibirMensagemSucesso,
  formatarData,
  formatarDinheiroItl,
  getUsuarioLogado,
  HttpVerbo,
  xfetch
} from "../../util";
import {PaginaLogada} from "../../componentes";
import {getCorPorPorcentagem} from '../../componentes/barra-progresso/barra-progresso';
import {
  Badge,
  Box,
  Card,
  Divider,
  Grid,
  Group,
  Modal,
  RingProgress,
  SimpleGrid,
  Text,
  Textarea,
  Title,
  Tooltip, useMantineTheme
} from '@mantine/core';
import {displayFlagStyle} from '../../util/util';
import classes from './principal.module.css';
import {
  IconAB2,
  IconCalendarCheck,
  IconCalendarExclamation,
  IconFileImport,
  IconFiles,
  IconFolderDollar,
  IconReceiptDollar,
  IconTarget,
  IconWallet
} from "@tabler/icons-react";
import {BotaoArquivar, BotaoExibir, BotaoFechar, BotaoTramitar} from '../../componentes/botao/botao-mantine';
import SetorSelect from "../../componentes/form/setor-select/setorSelect";
import {Projeto} from "../../tipos/projeto";
import {Setor} from "../../tipos/setor";
import {useDisclosure, useListState} from "@mantine/hooks";
import {COL_RESP_6, COR} from "../../config/constantes/constantes-mantine";

export default function Principal() {

  const theme = useMantineTheme();
  const [setor, setSetor] = useState(0)
  const [setorSelecionado, setSetorSelecionado] = useState<Setor | undefined>()
  const [setores, setSetores] = useState(new Array<Setor>())
  const [projetos, handleProjetos] = useListState<Projeto>()
  const [projetoModal, setProjetoModal] = useState(new Projeto())
  const [modalExibir, {open: openModalExibir, close: closeModalExibir}] = useDisclosure(false);
  const [modalTramitacao, {open: openModalTramitacao, close: closeModalTramitacao}] = useDisclosure(false);
  const [modalArquivar, {open: openModalArquivar, close: closeModalArquivar}] = useDisclosure(false);

  const [descricaoTramitacao, setDescricaoTramitacao] = useState('')
  const [isCarregando, setIsCarregando] = useState(false)
  const [setorTramitacao, setSetorTramitacao] = useState(0)

  const usuarioLogado = getUsuarioLogado()
  const isAdm = usuarioLogado?.roles?.find(r => r.role === 'ADM') !== undefined
  const isAdmOuCoordenador = usuarioLogado?.roles?.filter(u => u.role === 'COORDENADOR' || u.role === 'ADM').length > 0
  const corIcone = "#4263EB"

  function carregarProjetos() {
    setIsCarregando(true)
    if (isAdm) {
      const url = setor === 0 ? '/projeto' : '/projeto/setor/' + setor
      xfetch(url, {}, HttpVerbo.GET)
        .then(res => res.json())
        .then(json => {
          handleProjetos.setState(json)
        })
        .finally(() => setIsCarregando(false))
      return
    }

    if (usuarioLogado.setor) {
      xfetch('/projeto/setor/' + usuarioLogado.setor.id, {}, HttpVerbo.GET)
        .then(res => res.json())
        .then(json => {
          handleProjetos.setState(json)
        })
        .finally(() => setIsCarregando(false))
    }
  }

  function carregaSetores() {
    setIsCarregando(true)
    xfetch('/setor', {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => {
        setSetores(dados)
      })
      .finally(() => setIsCarregando(false))
  }

  function arquivarProjeto(projetoArquivar: Projeto) {
    if (!projetoArquivar) {
      exibirMensagemErro("Projeto não encontrado.")
      return
    }
    setIsCarregando(true)
    xfetch('/projeto/arquivar', {'projetoId': projetoArquivar.id}, HttpVerbo.POST)
      .then(res => res.json())
      .then(() => {
        exibirMensagemSucesso("Projeto arquivado com sucesso")
        closeModalArquivar()
        carregarProjetos()
      })
      .finally(() => setIsCarregando(false))
  }

  function enviarTramitacao() {

    if (usuarioLogado?.setor?.id === projetoModal.id) {
      exibirMensagemErro("Não é possivel tramitar para o detentor do projeto")
      return
    }
    setIsCarregando(true)
    const dados = {
      idProjeto: projetoModal.id,
      idSetor: setorTramitacao,
      descricao: descricaoTramitacao
    }
    xfetch("/tramitacao", dados, HttpVerbo.POST)
      .then(res => res.json())
      .then(dados => {
        exibirMensagemSucesso(`Projeto tramitado com sucesso`)
        closeModalTramitacao();
        setDescricaoTramitacao('')
      })
      .finally(() => {setIsCarregando(false); carregarProjetos()})
  }

  function getBadgeSetor(setor: Setor | undefined) {
    if (!setor || !setor.id) return <Badge variant="outline" color={"gray.4"} className={classes.badge}>Sem setor
      definido</Badge>
    if (setor.id && !setor.nome) return <Badge variant="outline" color={setorSelecionado?.cor}
                                               className={classes.badge}>{setorSelecionado?.nome}</Badge>
    return <Badge variant="outline" color={setor.cor} className={classes.badge}>{setor.nome}</Badge>
  }

  function getTituloProjeto(projeto: Projeto) {
    return projeto.numeroIgesp ? 'Projeto Nº ' + projeto.numeroIgesp : 'TERMO ' + projeto.nome
  }

  useEffect(() => {
    carregarProjetos()
    carregaSetores()
  }, [setor])

  return (
    <PaginaLogada isCarregando={isCarregando}>

      <Box style={displayFlagStyle(isAdm)} w={300} mb={50}>
        <SetorSelect label={"Projetos por setor"} setorId={setor} setSetorId={setSetor}/>
      </Box>

      <SimpleGrid cols={{base: 1, lg: 2, xxl: 3}}>
        {projetos.map((projeto) => {
            return <Card key={projeto.id} withBorder radius="md"
                         className={classes.card}
                         style={{borderColor: projeto.setor?.cor}}>
              <Card.Section className={classes.imageSection}>
                <Text mt={"sm"} fz="xl" className={classes.label}>
                  {getTituloProjeto(projeto)}
                </Text>
                {getBadgeSetor(projeto.setor)}
              </Card.Section>

              <Group justify="space-between" mt="md">
                <div>
                  <Text fz="xs" c="dimmed">
                    {projeto.nome}
                  </Text>
                </div>
              </Group>

              <Card.Section className={classes.section} mt="md">
                <Text fz="sm" c="dimmed" className={classes.label}>
                  Status
                </Text>
                <Grid grow>
                  <Grid.Col span={7}>
                    <SimpleGrid cols={2}>
                      <Tooltip label={"Data Início"}>
                        <Box>
                          <IconCalendarCheck color={corIcone} size={25} className={classes.icon} stroke={1.5}/>
                          <Text size="sm" component={"span"}>{formatarData(projeto.dataInicio?.toString())}</Text>
                        </Box>
                      </Tooltip>

                      <Tooltip label={"Data Limite"}>
                        <Box>
                          <IconCalendarExclamation color={corIcone} size={25} className={classes.icon} stroke={1.5}/>
                          <Text size="sm" component={"span"}>{formatarData(projeto.dataLimite?.toString())}</Text>
                        </Box>
                      </Tooltip>

                      <Tooltip label={"Fonte Recurso"}>
                        <Box>
                          <IconFolderDollar color={"brown"} size={25} className={classes.icon} stroke={1.5}/>
                          <Text size="sm" component={"span"}>{projeto.fonteRecurso}</Text>
                        </Box>
                      </Tooltip>

                      <Tooltip label={"Metas"}>
                        <Box>
                          <IconTarget color={"red"} size={25} className={classes.icon} stroke={1.5}/>
                          <Text size="sm" component={"span"}>{projeto.metas?.length}</Text>
                        </Box>
                      </Tooltip>
                    </SimpleGrid>
                    <Box mt={50}>
                      <Text fz="xl" fw={700} style={{lineHeight: 1}}>
                        <Badge size={"xl"} variant={"light"}
                               color={"green.8"}>{formatarDinheiroItl(projeto.valorTotal)}</Badge>
                      </Text>
                      <Text fz="sm" c="dimmed" fw={500} style={{lineHeight: 1}} mt={3}>
                        Valor Total
                      </Text>
                    </Box>
                  </Grid.Col>
                  <Grid.Col span={5}>
                    <div className={classes.ring}>
                      <RingProgress
                        roundCaps
                        thickness={6}
                        size={150}
                        sections={[{
                          value: projeto.pcExecutado!!,
                          color: getCorPorPorcentagem(projeto.pcExecutado!!)
                        }]}
                        label={
                          <div>
                            <Text ta="center" fz="lg" className={classes.labelRing}>
                              {projeto.pcExecutado}%
                            </Text>
                            <Text ta="center" fz="xs" c="dimmed">
                              Andamento do Projeto
                            </Text>
                          </div>
                        }
                      />
                    </div>
                  </Grid.Col>
                </Grid>
              </Card.Section>

              <Card.Section className={classes.section}>
                <Group gap={20}>
                  <BotaoExibir radius="xl" style={{flex: 1}} onClick={() => {
                    setProjetoModal(projeto)
                    openModalExibir()
                  }}>
                    Detalhes
                  </BotaoExibir>
                  <BotaoTramitar
                    radius="xl"
                    style={{flex: 1}}
                    disabled={!isAdmOuCoordenador}
                    onClick={() => {
                      setProjetoModal(projeto)
                      openModalTramitacao()
                    }}/>
                  <BotaoArquivar
                    radius="xl" style={{flex: 1}}
                    disabled={!isAdm}
                    onClick={() => {
                      setProjetoModal(projeto)
                      openModalArquivar()
                    }}/>
                </Group>
              </Card.Section>
            </Card>
          }
        )}
      </SimpleGrid>

      <Modal opened={modalExibir} onClose={closeModalExibir} size={"xl"} title={getTituloProjeto(projetoModal)}>
        <Text c={"dimmed"}>{projetoModal.nome}</Text>
        <Divider my={15}/>

        <Modal.Body>
          <Grid>
            <Grid.Col span={12}>
              <Box>
                <IconWallet color={"brown"}/> <b> Dados Bancários: </b> {projetoModal.contaBancaria}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconReceiptDollar color={"green"}/><b> Valor Total: </b>{formatarDinheiroItl(projetoModal.valorTotal)}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconFolderDollar color={corIcone}/><b> Fonte Recurso: </b>{projetoModal.fonteRecurso}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconCalendarCheck color={corIcone}/><b> Data Inicío: </b>{formatarData(projetoModal.dataInicio)}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconCalendarExclamation color={corIcone}/><b> Data Limite: </b>{formatarData(projetoModal.dataLimite)}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconAB2 color={corIcone}/><b> Convenio: </b>{projetoModal.convenio}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconFileImport color={corIcone}/><b> Número IGESP: </b>{projetoModal.numeroIgesp}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconFiles color={"gray"}/><b> Arquivos: </b>{projetoModal.arquivos?.length}
              </Box>
            </Grid.Col>
            <Grid.Col span={COL_RESP_6}>
              <Box>
                <IconTarget color={"red"}/><b> Metas: </b>{projetoModal.metas?.length}
              </Box>
            </Grid.Col>
          </Grid>
        </Modal.Body>
        <SimpleGrid cols={2}>
          <BotaoExibir onClick={() => window.location.assign('/projeto/' + projetoModal.id)}>
            Visualizar Projeto Completo
          </BotaoExibir>
          <BotaoFechar onClick={closeModalExibir}/>
        </SimpleGrid>
      </Modal>

      <Modal opened={modalTramitacao} onClose={() => {closeModalTramitacao(); setDescricaoTramitacao("")}} size="lg" title={getTituloProjeto(projetoModal)}>
        <Modal.Header>
          <Text c={"dimmed"}>{projetoModal.nome}</Text>
        </Modal.Header>
        <Modal.Body>
          <SetorSelect setorId={setorTramitacao} setSetorId={setSetorTramitacao} label={"Tramitar para"}/>
          <Textarea
            label={"Descrição"}
            autosize
            minRows={5}
            value={descricaoTramitacao}
            onChange={(e) => setDescricaoTramitacao(e.currentTarget.value)}
          />
          <SimpleGrid cols={2} mt={20}>
            <BotaoFechar onClick={() => {
              closeModalTramitacao()
              setDescricaoTramitacao("")
            }}/>
            <BotaoTramitar onClick={enviarTramitacao}/>
          </SimpleGrid>
        </Modal.Body>
      </Modal>

      <Modal opened={modalArquivar} onClose={closeModalArquivar} size="lg"
             title={'Arquivar ' + getTituloProjeto(projetoModal)}>
        <Modal.Body>
          <Title order={3}>
            Deseja realmente arquivar o {getTituloProjeto(projetoModal)}?
          </Title>
        </Modal.Body>
        <SimpleGrid cols={2}>
          <BotaoFechar onClick={() => closeModalArquivar()}/>
          <BotaoArquivar color={COR.PERIGO} onClick={() => arquivarProjeto(projetoModal)}/>
        </SimpleGrid>
      </Modal>
    </PaginaLogada>
  );
}
